import { render, staticRenderFns } from "./RequestPickupDetail.vue?vue&type=template&id=7bc30029&"
import script from "./RequestPickupDetail.vue?vue&type=script&lang=js&"
export * from "./RequestPickupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports